// import { Injectable } from '@angular/core';
// import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
// import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';
// import { JwtInterceptor } from './request.interceptor';



// @Injectable()
// export class ErrorInterceptor implements HttpInterceptor {


//     constructor( private JwtInterceptor: JwtInterceptor) {

//     }

//     intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         return next.handle(request)
//         // .pipe(catchError(err => {
//         //     let error = err.error && err.error.message ? err.error.message : err.statusText;
//         //     if (err instanceof HttpErrorResponse) {

//         //         if (err.status === 401) {

//         //         } 



//         //         return throwError(err);
//         //     }

//         // }
//         // ))


//     }
//     addTokenHeader(request: HttpRequest<any>, token: string) {
//         return request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
//     }


// }

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, timeout } from "rxjs/operators";
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { DataService } from 'src/app/shared/constants/data.service';
import { apiServiceMessageError, customeErrorMessage } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OidcClientManagerService } from 'src/app/login-layout/service-oidc/oidc-client-manager.service';
import { GlobalProperties } from 'src/app/global/global-properties';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
   errorMessage !: string;
   currentUserInfo: any
   companyList: any[] = []; // Initialize companyList to an empty array
   selectedCompany: any = '';
   selectedCompanyData: any = null; // Initialize selectedCompanyData to nul
   constructor(public snackbarService: BaseService<any>, public router: Router, private oidcClientManager: OidcClientManagerService, private ngxUiLoaderService: NgxUiLoaderService, public dataService: DataService, public generic: GenericService<any>) {
   }

   intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      return next.handle(request)
         .pipe(
            catchError((error: HttpErrorResponse) => {

               //   this.dataService.totalRequests--;
               let errorMsg = '';

               if (error.error instanceof ErrorEvent) {

                  errorMsg = `Error: ${error.error.message}`;

                  this.errorMessage = error.error.message;
               } else if (request.url.includes('DraftsService_SaveDraftToDocument')) {
                  this.snackbarService.showMessage(error?.error?.error?.message?.value, 'X');

               } if (error?.error?.error?.code == "-2028") {
                  this.snackbarService.showMessage('Document Sent For Approval', 'X');
                  this.router.navigate(['approval-process/orignatorPendingReuests']);
               } else if (request.url.includes('Orders') && error.status === 404) {

                  this.snackbarService.showMessage('Document Send For Approval', 'X');
                  this.router.navigate(['home/sales/salesOrderListView']);
               }
               else if (request.url.includes('Invoices') && error.status === 404 && (request.method == 'POST' || request.method == 'PATCH')) {
                  console.log('requestttttttt', request)

                  this.snackbarService.showMessage('Document Send For Approval', 'X');
                  this.router.navigate(['home/sales/salesInvoiceListView']);
               } else if (request.url.includes('Quotations') && error.status === 404 && (request.method == 'POST' || request.method == 'PATCH')) {
                  this.snackbarService.showMessage('Document Send For Approval', 'X');
                  this.router.navigate(['home/sales/salesQutationListView']);
               }
               else {

                  let extractedError = error?.error?.error?.message?.value || error?.error?.error?.message || error?.error?.error || error?.error?.Message || error?.message || "Unknown error";
                  if (typeof extractedError === 'object') {
                     extractedError = JSON.stringify(extractedError);
                  }

                  errorMsg = `Error Code: ${error.status},  Message: ${extractedError}`;
                  this.errorMessage = extractedError;
                  const keywords = ['uneecopscloud', 'ubshanacloud'];

                  if (error?.error?.error?.code == "-2028") {
                     this.snackbarService.showMessage('Document Sent For Approval', 'X');
                     this.router.navigate(['approval-process/orignatorPendingReuests']);

                  }
                  else {

                     this.snackbarService.showMessage(extractedError, 'X');
                     if (keywords.some(word => request.url.includes(word))) {


                        if (error.status == 401) {

                           this.oidcClientManager.startSignoutRedirect()

                        }

                     }

                  }

               }
               if (this.errorMessage == apiServiceMessageError.tableAlreadyExisted || this.errorMessage == apiServiceMessageError.panNumberStatus || this.errorMessage == apiServiceMessageError.PeriodIndicatorStatus || this.errorMessage == apiServiceMessageError.headerRowLevelWarehouseDifferentStatus || this.errorMessage == apiServiceMessageError.fromToWarehouseSameStatus || this.errorMessage == apiServiceMessageError.seriesStatus || this.errorMessage == apiServiceMessageError.branhcMasterError || this.errorMessage == apiServiceMessageError.documnetnumbering || this.errorMessage == apiServiceMessageError.itemmaster || this.errorMessage == apiServiceMessageError.salesstages || this.errorMessage == apiServiceMessageError.itemGroupError) {
                  var er: any;
                  var er1: any;
                  var er2: any;

                  if (this.dataService.tableName == 'Users') {
                     er = customeErrorMessage.userMasterError;
                  }
                  if (this.dataService.tableName == 'Location') {
                     er = customeErrorMessage.locationMasterError
                     er1 = customeErrorMessage.panNumberError
                  }
                  else if (this.dataService.tableName == 'CurrencySetup') {
                     er = customeErrorMessage.currencySetupError
                  }
                  else if (this.dataService.tableName == 'ProjectMaster') {
                     er = customeErrorMessage.projectMasterError
                  }
                  else if (this.dataService.tableName == 'CustomerGroup') {
                     er = customeErrorMessage.customerGrp
                  }
                  else if (this.dataService.tableName == 'VendorGroup') {
                     er = customeErrorMessage.vendorGrp
                  }
                  else if (this.dataService.tableName == 'CurrencySetup') {
                     er = customeErrorMessage.currencyError
                  }
                  else if (this.dataService.tableName == 'SalesEmp') {
                     er = customeErrorMessage.salesEmpError
                  }
                  else if (this.dataService.tableName == 'PaymentTerm') {
                     er = customeErrorMessage.paymentTermErr
                  }
                  else if (this.dataService.tableName == 'Competitors') {
                     er = customeErrorMessage.CompetitorsNameError
                  }
                  else if (this.dataService.tableName == 'RelationshipMaster') {
                     er = customeErrorMessage.RelationshipMasterNameError
                  }
                  else if (this.dataService.tableName == 'ChartOfAccount') {
                     er = customeErrorMessage.ChartOfAccountError
                  }
                  else if (this.dataService.tableName == 'CostCenter') {
                     er = customeErrorMessage.CostCenterError
                  }
                  else if (this.dataService.tableName == 'WarehouseMaster') {
                     er = customeErrorMessage.warehouseMasterError
                  }
                  else if (this.dataService.tableName == 'DepartmentMaster') {
                     er = customeErrorMessage.departmentMasterError
                  }
                  // else if (this.dataService.tableName == 'UserMaster') {
                  //    er = customeErrorMessage.departmentMasterError
                  // }
                  else if (this.dataService.tableName == 'HouseBankMaster') {
                     er = customeErrorMessage.houseBankMasterError
                  }
                  else if (this.dataService.tableName == 'DocumentNumberingSetup') {
                     er = customeErrorMessage.documentNumberingError
                     er1 = customeErrorMessage.documentNumberingSeriesOverlap
                  }
                  // else if(this.dataService.tableName=='Activity')
                  // {
                  //    er=customeErrorMessage.activityInactiveError
                  // }
                  else if (this.errorMessage == apiServiceMessageError.salesstages) {
                     if (this.dataService.tableName == 'SalesStages') {
                        er = customeErrorMessage.salesStagesError
                     }
                  }
                  else if (this.dataService.tableName == 'SalesStages') {
                     er = customeErrorMessage.stageMasterError
                  }
                  else if (this.dataService.tableName == 'CreditCards') {
                     er = customeErrorMessage.creditCardError
                  }
                  else if (this.dataService.tableName == 'Partners') {
                     er = customeErrorMessage.PartnersError
                  }
                  else if (this.dataService.tableName == 'PeriodIndicatorMaster') {
                     er = customeErrorMessage.periodIndicatorMasterError
                  }
                  else if (this.dataService.tableName == 'TransporterMaster') {
                     er = customeErrorMessage.TranspoterMasterError
                  }
                  else if (this.dataService.tableName == 'StockTransfers') {
                     er = customeErrorMessage.periodIndicatorError
                     er1 = customeErrorMessage.quantityError
                     er2 = customeErrorMessage.fromToWarehouseSameError
                  }
                  else if (this.dataService.tableName == 'InventoryGenExits') {
                     er = customeErrorMessage.seriesError
                  }
                  // else if (this.dataService.tableName == 'ProductTrees') {
                  //    er = customeErrorMessage.billofmaterialError
                  // }
                  else if (this.dataService.tableName == 'InventoryCounting') {
                     er = customeErrorMessage.InventoryCountingError
                  }
                  else if (this.dataService.tableName == 'BranhcMaster') {
                     er = customeErrorMessage.branhcMasterError1
                  }
                  else if (this.dataService.tableName == 'ItemMaster') {
                     er = customeErrorMessage.itemMasterError
                  }
                  else if (this.dataService.tableName == 'ItemGroup') {
                     er = customeErrorMessage.itemGroupError
                  }


                  this.dataService.openDialogBoxSubject.next(er);
                  er = 0;
                  this.dataService.openDialogBoxSubject.next(er);

               }
               else if (this.errorMessage == apiServiceMessageError.branhcMasterError) {
                  if (this.dataService.tableName == 'BranhcMaster') {
                     er = customeErrorMessage.branhcMasterError1
                  }

               }


               return throwError(errorMsg);
            })
         )
   }



   loginSSO() {
      sessionStorage.setItem('loginWithSSO', 'true')

      const clientSettings = {
         // Add your required OIDC client settings here
         // client_id: 'b1-ext-0117680e-d806-4fc6-9501-6fb2f023ab0b', //localhost 3300
         client_id: 'b1-ext-7a025106-cd2c-4727-a9e1-0a3d5712a078', //erp.ubshanacloud.in
      };
      let sldAddress = "https://ubsdemo.ubshanacloud.in:40000/sld/sld0100.svc";
      // let slBaseUrl = "https://ubsdemo.ubshanacloud.in:50000/b1s/v2";

      this.oidcClientManager.init(clientSettings, sldAddress + '/GetOpenIDConnectProvider', sldAddress + '/CurrentUserInfo')
         .then(() => {
            this.oidcClientManager.getBindingCompaniesInfo()
               .then((companyListRes: any) => {
                  // Call your UI binding function here, e.g.:
                  // this.bindCompanyListUI(companyList);
                  let sapInfo: any = GlobalProperties.getSapInfo;
                  this.currentUserInfo = companyListRes.d.CurrentUserInfo.UserName;
                  this.companyList = companyListRes.d.CurrentUserInfo.B1UserBindings.results; // Store the company list in the component property


                  this.companyList = this.companyList.filter(res => {

                     return res.CompanySchemaName == sapInfo.CompanyDB

                  })
               })
               .catch((err: any) => {
                  alert("get binding user info failed: " + err);
               });
         })
         .catch((err: any) => {
            if (err.message === "access_denied") {
               alert("Current user does not have permission to access company");
               this.oidcClientManager.startSignoutRedirect();
            } else {
               alert(err);
            }
         });

   }
}
